import "./index.scss";
import React from "react";
import HeaderPersonalAccount from "components/common/headerPersonalAccount";
import Footer from "components/common/footer";
import LeftMenu from "components/common/leftMenu";
import { Outlet } from "react-router-dom";

const PersonalCabinetLayout = ({ ...props }) => {
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <>
      <div className="cabinet-wrapper">
        <div className="layout-container">
          <div className="sidebar-menu">
            <LeftMenu />
          </div>
          <div className="main-content">
            <HeaderPersonalAccount />
            <div className={`div-section-content ${loaded ? "loaded" : ""}`}>
              <Outlet />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default PersonalCabinetLayout;
